import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import LinkCard from '../../../../components/LinkCard/LinkCard';

const HomepageBigPromise = () => {
  const mobile = window.innerWidth < 1020;
  return (
    <section className="white">
      <div
        className={mobile ? 'homepage-jumbotron-mobile' : 'homepage-jumbotron'}
      >
        <div className="homepage-jumbotron-content">
          <h1>
            <FormattedMessage
              id="homepage.bigPromiseHeader"
              defaultMessage="Now is the time to go electric."
              description="Homepage jumbotron header"
            />
          </h1>
          <p>
            <FormattedMessage
              id="homepage.bigPromiseParagraph"
              defaultMessage="Estimate and compare costs, savings, incentives and more."
              description="Homepage jumbotron paragraph"
            />
          </p>
        </div>
      </div>
      <div className="link-card-container">
        <div className="grid-item">
          <LinkCard
            title={
              <FormattedMessage
                id="homepage.researchEVs"
                defaultMessage="Research EVs"
                description="Homepage link card: Research EVs"
              />
            }
            link={`/vehicles`}
          />
        </div>
        <div className="grid-item">
          <LinkCard
            title={
              <FormattedMessage
                id="homepage.compareVehicles"
                defaultMessage="Compare vehicles"
                description="Homepage link card: Compare vehicles"
              />
            }
            link={`/compare-vehicles`}
          />
        </div>
        <div className="grid-item">
          <LinkCard
            title={
              <FormattedMessage
                id="homepage.maximizeIncentives"
                defaultMessage="Maximize incentives"
                description="Homepage link card: Maximize incentives"
              />
            }
            link={`/incentives`}
          />
        </div>
        <div className="grid-item">
          <LinkCard
            title={
              <FormattedMessage
                id="homepage.compareEvRates"
                defaultMessage="Compare EV rates"
                description="Homepage link card: Compare EV rates"
              />
            }
            link={`/rates`}
          />
        </div>
        <div className="grid-item">
          <LinkCard
            title={
              <FormattedMessage
                id="homepage.findChargingStations"
                defaultMessage="Find charging stations"
                description="Homepage link card: Find charging stations"
              />
            }
            link={`/charging-stations`}
          />
        </div>
        <div className="grid-item">
          <LinkCard
            title={
              <FormattedMessage
                id="homepage.browseHomeChargers"
                defaultMessage="Browse home chargers"
                description="Homepage link card: Browse home chargers"
              />
            }
            link={`/home-chargers`}
          />
        </div>
        <div className="grid-item">
          <LinkCard
            title={
              <FormattedMessage
                id="homepage.browseEvInventory"
                defaultMessage="Browse EV inventory"
                description="Homepage link card: Browse EV inventory"
              />
            }
            link={`/inventory`}
          />
        </div>
        <div className="grid-item">
          <LinkCard
            title={
              mobile ? (
                <FormattedMessage
                  id="homepage.discoverEvContent"
                  defaultMessage="Discover EV content"
                  description="Homepage link card: Discover EV content (mobile)"
                />
              ) : (
                <FormattedMessage
                  id="homepage.discoverEvContentFaq"
                  defaultMessage="Discover EV content & FAQs"
                  description="Homepage link card: Discover EV content & FAQs (desktop)"
                />
              )
            }
            link={`/faq`}
          />
        </div>
      </div>
    </section>
  );
};

export default HomepageBigPromise;

HomepageBigPromise.propTypes = {
  homePageBannerImage: PropTypes.string,
  userLocation: PropTypes.string,
};
